export { default } from './TreeView';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/TreeView/index.js
// module id = 392
// module chunks = 0